module.exports = __webpack_public_path__ + "static/media/colored-dream.0c1fbb14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/colored-dream.jpg
// module id = 287
// module chunks = 0